// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__251WZ","label":"styles_label__3Zlhz"};